import { NIM } from '@yxim/nim-web-sdk/dist/SDK/NIM_Web_NIM';
import { nimEventReport } from 'components/Nim/nimReport';

type Methods = keyof Pick<NIM, 'sendCustomMsg' | 'sendCustomSysMsg'>;

export const promisify = (__instance__: NIM | null, method: Methods) => {
  if (!__instance__) {
    throw new Error('should not call a Nim instance method before initialize');
  }

  const cb = __instance__[method];

  type CB = typeof cb;
  type Args = Parameters<CB>;
  type Done = NonNullable<Args[0]['done']>;
  type Return = Parameters<Done>[1];
  type FirstArg = Omit<Args[0], 'done'>;
  type RestArgs = Util.OmitFirst<Args>;

  return (first: FirstArg, ...rest: RestArgs): Promise<Return> => {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      cb.call(__instance__, {
        ...first,
        done: (err, data: Return) => {
          if (err) {
            nimEventReport('nim_promisify_catch', {
              error: err,
              event: method,
              args: [first].concat(rest),
            });
            reject(new Error(err));
          } else {
            resolve(data);
          }
        },
      });
    });
  };
};
